import { render, staticRenderFns } from "./DialogTitle.vue?vue&type=template&id=6ed2862c&scoped=true"
import script from "./DialogTitle.vue?vue&type=script&lang=js"
export * from "./DialogTitle.vue?vue&type=script&lang=js"
import style0 from "./DialogTitle.vue?vue&type=style&index=0&id=6ed2862c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed2862c",
  null
  
)

export default component.exports